import palette from '../palette';
export default {
  defaultProps: {
    color: 'secondary'
  }
};
